/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_CustompageInputs */

const en_entity_custompage = /** @type {(inputs: Entity_CustompageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Page`)
};

const de_entity_custompage = /** @type {(inputs: Entity_CustompageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzseite`)
};

/**
* | output |
* | --- |
* | "Custom Page" |
*
* @param {Entity_CustompageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_custompage = /** @type {((inputs?: Entity_CustompageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_CustompageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompage(inputs)
	return de_entity_custompage(inputs)
});